import { configureStore } from "@reduxjs/toolkit";
import propertyReducer from "./propertySlice";
import authReducer from "./authSlice";
import employeeReducer from "./employeeSlice";
import clientReducer from "./clientSlice";
import membersReducer from "./membersSlice";
import repairsReducer from "./repairSlice";
import toastReducer from "./toastSlice";
import propertySectionsReducer from "./propertySectionSlice";
import categoryManagementReducer from "./categoryManagementSlice";
import chatReducer from "./chatSlice";
import emailDomainReducer from "./emailDomainSlice";
import aiUsageReducer from "./aiUsageSlice";

export const store = configureStore({
  reducer: {
    property: propertyReducer,
    auth: authReducer,
    employees: employeeReducer,
    clients: clientReducer,
    members: membersReducer,
    repairs: repairsReducer,
    toast: toastReducer,
    propertySections: propertySectionsReducer,
    categoryManagement: categoryManagementReducer,
    chat: chatReducer,
    emailDomain: emailDomainReducer,
    aiUsage: aiUsageReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
